<template>
  <v-form fast-fail class="edit-user" v-click-outside="cancelAction">
    <h2 class="title mb-2">
      {{ $t("ticketBuyerTypes.modal.title") }}
    </h2>
    <v-select
      :label="$t('ticketBuyerTypes.modal.label')"
      v-model="type"
      :items="typesWithId"
      item-title="type"
      item-value="id"
      clearable
    ></v-select>

    <div class="btn-row mt-6">
      <v-btn @click="cancelAction">
        {{ $t("ticketBuyerTypes.modal.cancel") }}
      </v-btn>
      <v-btn :disabled="!visibleButton" color="primary" @click="handleSaveType">
        {{ $t("ticketBuyerTypes.modal.save") }}
      </v-btn>
    </div>
  </v-form>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "TicketBuyerTypesModal",
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      type: null,
      /* types: [], */
      typesWithId: [],
    };
  },
  created() {
    this.getTypeList();
  },
  methods: {
    ...mapActions({
      getWebshopUserType: "users/getWebshopUserType",
    }),
    cancelAction() {
      if (document.activeElement.tagName != "INPUT") {
        this.emitter.emit("closeModal");
      }
    },
    handleSaveType() {
      const createPayload = {
        type_id: this.type,
        id: this.id,
      };
      this.$emit("selectedType", createPayload);
      this.emitter.emit("closeModal");
    },
    getTypeList() {
      this.getWebshopUserType()
        .then((response) => {
          /* this.types = response.list.map((type) => type.title); */
          this.typesWithId = response.list.map((type) => {
            return { id: type.id, type: type.title };
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  computed: {
    visibleButton() {
      return this.type !== null;
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-user {
  min-width: 400px;
  padding: 24px;
  @media (max-width: 520px) {
    min-width: 300px;
    padding: 12px;
  }
  .btn-row {
    display: flex;
    justify-content: space-between;
    @media (max-width: 520px) {
      flex-direction: column;
      gap: 12px;
    }
  }
}
</style>
